import React from 'react';
import clsx from 'clsx';
import Select from 'react-select';

import { makeStyles } from '@mui/styles';

import { NoSsr, Chip, Paper, TextField, Typography } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';
import DropdownIndicatorIcon from '@mui/icons-material/ArrowDropDown';
import CommonStyles from './CommonStyles';

const useStyles = makeStyles(() => ({
  valueContainer: {
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
  },
  singleValue: {
    fontSize: '12px',
  },
  placeholder: {
    left: 5,
    color: '#7978A8',
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'italic',
    position: 'absolute',
  },
  paper: {
    left: 0,
    right: 0,
    zIndex: 2,
    position: 'absolute',
    boxShadow: '0 5px 5px -3px rgba(0,0,0,0.2)',
    '& .css-11unzgr::-webkit-scrollbar': {
      width: '3px',
      background: 'rgba(0,0,0, 0.2)',
    },
    '& .css-11unzgr::-webkit-scrollbar-track': {
      borderRadius: '5px',
      background: '#BCBCBC',
    },
    '& .css-11unzgr::-webkit-scrollbar-thumb': {
      background: '#878787',
      borderRadius: '10px',
    },
  },
  input: {
    ...CommonStyles.input,
  }
}));

const NoOptionsMessage = (props) => (
  <Typography
    color="textSecondary"
    className={props.selectProps.classes.noOptionsMessage}
    style={{
      fontSize: '12px',
      minHeight: '24px',
      padding: '0 16px',
      lineHeight: 'normal',
      fontWeight: props.isSelected ? 500 : 400,
    }}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
);

const inputComponent = React.forwardRef((props, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      style={{
        fontSize: '12px',
      }}
    />
  )
});

// const inputComponent = ({ inputRef, ...props }) => (
//   <div
//     {...props}
//     ref={inputRef}
//     style={{
//       fontSize: '12px',
//     }}
//   />
// );

const Control = ({ children, innerProps, innerRef, selectProps: { classes, TextFieldProps } }) => (
  <TextField
    fullWidth
    InputProps={{
      inputComponent,
      inputProps: {
        className: `autocomplete-input ${classes.input}`,
        ref: innerRef,
        children,
        ...innerProps,
      },
    }}
    {...TextFieldProps}
  />
);

const Option = (props) => (
  <div
    ref={props.innerRef}
    onMouseEnter={(e) => e.currentTarget.style.background = '#DBD9E7'}
    onMouseLeave={(e) => e.currentTarget.style.background = '#fff'}
    style={{
      fontSize: '12px',
      minHeight: '24px',
      padding: '0 16px',
      lineHeight: '24px',
      fontWeight: props.isSelected ? 600 : 400,
      cursor: 'pointer',
      background: props.isFocused ? '#DBD9E7' : '',
    }}
    {...props.innerProps}
  >
    {props.children}
  </div>
);

const Placeholder = (props) => (
  <Typography
    color="textSecondary"
    className={`${props.selectProps.classes.placeholder} autocomplete-placeholder`}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
);

const SingleValue = (props) => (
  <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
    {props.children}
  </Typography>
);

const ValueContainer = (props) => <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;

const MultiValue = (props) => (
  <Chip
    tabIndex={-1}
    label={props.children}
    onDelete={props.removeProps.onClick}
    deleteIcon={<CancelIcon {...props.removeProps} />}
    className={clsx(props.selectProps.classes.chip, {
      [props.selectProps.classes.chipFocused]: props.isFocused,
    })}
  />
);

const Menu = (props) => (
  <Paper square {...props.innerProps} className={props.selectProps.classes.paper}>
    {props.children}
  </Paper>
);

const DropdownIndicator = () => (
  <DropdownIndicatorIcon
    style={{
      left: '6px',
      color: '#C4C4C4',
      position: 'relative',
    }}
  />
);

const components = {
  Menu,
  Option,
  Control,
  MultiValue,
  Placeholder,
  SingleValue,
  ValueContainer,
  NoOptionsMessage,
  DropdownIndicator,
};

export default function ({ style, value, options, onChange, multiple, placeholder, isClearable, className }) {
  const classes = useStyles();

  const selectStyles = {
    input: (base) => ({
      ...base,
      '& input': {
        font: 'inherit',
      },
    }),
  };

  return (
    <div style={{ ...style }}>
      <NoSsr>
        <Select
          value={value}
          options={options}
          classes={classes}
          isMulti={multiple}
          onChange={onChange}
          styles={selectStyles}
          components={components}
          isClearable={isClearable}
          placeholder={placeholder || 'Choose predicate'}
          className={`${classes.trplSelectMenu} ${className || ''}`}
        />
        <div className={classes.divider} />
      </NoSsr>
    </div>
  );
}
